export default "__VITE_ASSET__BRyTsReB__"